import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import _ from "lodash";
import { Search, Close } from "@mui/icons-material";


export const ProjectDropDown = ({
  handleChange,
  projectGoodsInDropdownValue,
  clientId
}) => {
  // Use selector
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const projects = useSelector((state) => { return clientId?.projects });

  // hook state
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false);
  let dataShown = []

  // Useeffect
  useEffect(() => {
    dataShown = _.orderBy(projects, ['name'], ["asc"])
    setFilteredData([...dataShown])
  }, [projects])

  useEffect(() => {
    dispatch(isDropdownOpenFlag(open));
  }, [open]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // handler functions
  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value)
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm === '') {
      let d = _.orderBy(projects, ['name'], ["asc"])
      setFilteredData([...d])
    } else {
      const filtered = filteredData.filter((item) => item.name.toLowerCase().includes(searchTerm));
      let data = _.orderBy(filtered || [], ['name'], ["asc"])
      setFilteredData([...data]);
    }
  };

  const onElementClicked = (item) => {
    handleChange(item);
    setOpen((prevOpen) => !prevOpen);
  };
  
  const onButton = () => {
    {
      filteredData.length > 0
        ? setOpen((prevOpen) => !prevOpen)
        : setOpen(false);
    }
  };

  return (
    <>
      <div ref={dropdownRef}>
        <div style={{ flex: 1, color: "white" }}>
          <div className="wrapper">
            <Tooltip
              title={
                projects?.length > 0 ? (
                  ""
                ) : (
                  <span className="project-dropdown-tooltip-style">
                    Please select client first
                  </span>
                )
              }
            >
              <div
                className="button d-flex flex-row justify-content-between"
                onClick={() => onButton()}
              >
                <Tooltip title={projectGoodsInDropdownValue.name == "ALL PROJECTS" ? "" : <span className="project-dropdown-tooltip-style1 project-dropdown-tooltip-style">{`${projectGoodsInDropdownValue.name || "All Projects"}`}</span>} arrow>
                  <span className="projectname-wrap">
                    {projectGoodsInDropdownValue.name || "ALL PROJECTS"}

                  </span>
                </Tooltip>
                {open ? (
                  <span>
                    <i className="bi bi-chevron-up chevron-up-arrow"></i>
                  </span>
                ) : (
                  <span>
                    <i className="bi bi-chevron-down chevron-down-arrow"></i>
                  </span>
                )}
              </div>
            </Tooltip>
            {projects?.length > 0 && open && (
              <>
                <div className={`content`}>
                  <div style={{ position: "relative", background: "#0045d9" }}>
                    <input
                      style={{ position: "relative", width: "100%" }}
                      className="search-field-input"
                      type="text"
                      placeholder="Search by name..."
                      value={searchValue}
                      onChange={handleSearchInputChange}
                    />
                    {searchValue !== "" ? (
                      <Close
                        style={{ cursor: "pointer" }}
                        onClick={handleClearSearchText}
                        className="search-icon-depotpersonal-style"
                      />
                    ) : (
                      <Search className="search-icon-depotpersonal-style" />
                    )}
                  </div>
                  {[{ name: "ALL PROJECTS", value: 0 }, ...filteredData]?.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div className={
                          projectGoodsInDropdownValue?.name === item.name ? `selected-dropdownfield` : ""
                        }
                          onClick={() => onElementClicked(item)}>
                          {item.name}
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
